import { useAcl } from '@contexts/acl'
import { useUserContext } from '@contexts/user'
import { useCalcDatesForPromotion } from '@hooks/useCalcDatesForPromotion'
import { ACCOUNT } from '@routes/path'
import {
  Badge,
  Button,
  CountdownTimer,
  Image,
  Paragraph,
  Spacer,
  Spreader
} from '@ui-kit'
import { Fragment } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Column, Row } from 'simple-flexbox'

import styles from './FreePlansTriggerToUpgrade.module.scss'
import { getBadgeContent, getCorrectImage, getVoucherValue } from './helpers'

export const FreePlansTriggerToUpgrade = () => {
  const { t } = useTranslation()

  const { accountCurrency, language } = useUserContext()

  const hasAccessToChangePlan = useAcl('plan.change_plan')

  const navigate = useNavigate()

  const handleRedirectToPricing = () => {
    navigate(ACCOUNT.ACCOUNT_PACKAGE)
  }

  const { date } = useCalcDatesForPromotion()

  const badgeContent = getBadgeContent(accountCurrency)

  const image = getCorrectImage(language || 'en')

  const voucherValue = t(getVoucherValue(accountCurrency))

  return (
    <Fragment>
      <Row alignItems='center'>
        <Image
          height='79px'
          src={image}
          alt='Benefits of upgrading to a higher plan'
        />

        <Spreader spread={15} />

        <Column>
          <Paragraph>
            <Trans
              i18nKey='infobar.free.plans.trigger.header'
              components={{
                b: <b />
              }}
            />

            <Spreader spread={15} />

            <Badge variant='success-filled' weight={600}>
              {t(badgeContent)}
            </Badge>
          </Paragraph>

          <Spacer space={5} />

          <Paragraph size={12}>
            <Trans
              i18nKey='infobar.free.plans.trigger.paragraph'
              components={{
                promo: <span className={styles.promo} />
              }}
              values={{
                voucherValue
              }}
            />
          </Paragraph>
        </Column>
      </Row>

      <Row className={styles.rightColumn}>
        <Fragment>
          <CountdownTimer {...date} variant='success' />

          {hasAccessToChangePlan && (
            <Fragment>
              <Spreader spread={15} />

              <Button onClick={handleRedirectToPricing}>
                <Trans i18nKey='infobar.free.plans.button.compare.plans' />
              </Button>
            </Fragment>
          )}
        </Fragment>
      </Row>
    </Fragment>
  )
}

FreePlansTriggerToUpgrade.displayName = 'TopbarInfobarFreePlansTriggerToUpgrade'
